import { render } from "./GameList.vue?vue&type=template&id=0eb2b66c&ts=true"
import script from "./GameList.vue?vue&type=script&lang=ts"
export * from "./GameList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__